import { CdkRowDef } from '@angular/cdk/table';
import { Directive, Input } from '@angular/core';
import { MatRowDef, MatTableDataSource } from '@angular/material/table';
import { Observable } from 'rxjs';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[typeSafeMatRowDef]',
  providers: [{ provide: CdkRowDef, useExisting: TypeSafeMatRowDefDirective }],
})
export class TypeSafeMatRowDefDirective<T, TDataSource> extends MatRowDef<T> {
  @Input({ required: true }) typeSafeMatRowDefDataSource: TDataSource[] | Observable<TDataSource[]> | MatTableDataSource<TDataSource>;
  @Input() set typeSafeMatRowDefColumns(value: Iterable<string>) {
    this.columns = value;
  }

  static ngTemplateContextGuard<T, TDataSource>(
    _dir: TypeSafeMatRowDefDirective<T, TDataSource>,
    _ctx: unknown,
  ): _ctx is { $implicit: TDataSource; index: number } {
    return true;
  }
}
